import React from 'react';
import './Profile.css';

function Profile() {
  const handleDownloadCV = () => {
    // Trigger print dialog which will show the resume
    window.print();
  };

  return (
    <section id="profile">
      <div className="section__pic-container">
        <img src="./assets/profile-pic.jpeg" alt="Prakash profile picture" />
      </div>
      <div className="section__text">
        <p className="section__text__p1 outfit-semibold">Hello, I'm</p>
        <h1 className="title playfair-display-bold">Prakash Choudhary</h1>
        <p className="section__text__p2 outfit-bold">Full Stack Developer | ML Engineer</p>
        <div className="btn-container">
          <button className="btn btn-color-1" onClick={handleDownloadCV}>
            Download CV
          </button>
          <button className="btn btn-color-2" onClick={() => window.location.href = '#contact'}>
            Contact Info
          </button>
        </div>
        <div id="socials-container">
          <img 
            src="./assets/whatsapp1.png" 
            alt="My whatsapp profile" 
            className="icon"
            onClick={() => window.location.href = 'https://whatsapp.com/channel/0029VaxfDrJ2ZjChra3bTn3G'}
          />
          <img 
            src="./assets/github.png" 
            alt="My Github profile" 
            className="icon"
            onClick={() => window.location.href = 'https://github.com/pc-daukiya'}
          />
          <img 
            src="./assets/linkedin.png" 
            alt="My LinkedIn profile" 
            className="icon"
            onClick={() => window.location.href = 'https://www.linkedin.com/in/codepc'}
          />
          <img 
            src="./assets/instagram1.jpeg" 
            alt="My Instagram profile" 
            className="icon"
            onClick={() => window.location.href = 'https://www.instagram.com/pc_daukiya?igsh=MW9pdTdxM3oycGlz'}
          />
          <img 
            src="./assets/threads1.jpg" 
            alt="My Threads profile" 
            className="icon"
            onClick={() => window.location.href = 'https://www.threads.net/@pc_daukiya'}
          />
          <img 
            src="./assets/twitter.png" 
            alt="My Twitter profile" 
            className="icon"
            onClick={() => window.location.href = 'https://x.com/Pc_daukiya?t=iedTk9F8KMWQzVILjimgjA&s=09'}
          />
        </div>
      </div>
    </section>
  );
}

export default Profile;
